<lib-card>
  <ng-container title> Aree </ng-container>
  <ng-container content>
    <div class="flex w-full flex-col gap-7 pb-1 pt-4">
      <div class="flex flex-col gap-3">
        <div class="flex items-center justify-between px-1">
          <div class="flex items-center gap-2 text-green-700">
            <i class="pi pi-check-circle text-lg"></i>
            <span class="text-sm font-bold uppercase tracking-wide">Aree di Forza</span>
          </div>
          <div class="hidden gap-1 lg:flex">
            <p-button
              icon="pi pi-chevron-left"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              styleClass="h-2rem w-2rem"
              (onClick)="scroll('left', 'strength')"
              [disabled]="strengthDivIsAtStart()"
            ></p-button>
            <p-button
              icon="pi pi-chevron-right"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              styleClass="h-2rem w-2rem"
              (onClick)="scroll('right', 'strength')"
              [disabled]="strengthDivIsAtEnd()"
            ></p-button>
          </div>
        </div>

        <div
          #strengthScroll
          class="custom-scrollbar grid w-full snap-x snap-mandatory grid-cols-1 gap-4 scroll-smooth lg:flex lg:overflow-x-auto lg:pb-4"
        >
          @for (area of strengthAreas(); track $index) {
            <div
              class="flex flex-none snap-start flex-col justify-between rounded-xl border-l-4 border-green-500 bg-slate-50 p-4 shadow-sm lg:w-[250px]"
            >
              <div class="flex flex-col">
                <div class="flex items-center justify-between">
                  <span class="text-sm font-bold uppercase text-green-600">{{ area.title }}</span>
                </div>
                <div class="mb-2 text-xs font-bold uppercase text-green-600">
                  Eccellenza {{ $index + 1 }}
                </div>
                <p class="m-0 text-base font-semibold leading-snug text-slate-800">
                  {{ area.details }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="flex flex-col gap-3" data-tour="result-weaknesses">
        <div class="flex items-center justify-between px-1">
          <div class="flex items-center gap-2 text-red-700">
            <i class="pi pi-exclamation-circle text-lg"></i>
            <span class="text-sm font-bold uppercase tracking-wide">Aree da migliorare</span>
          </div>
          <div class="hidden gap-1 lg:flex">
            <p-button
              icon="pi pi-chevron-left"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              styleClass="h-2rem w-2rem"
              (onClick)="scroll('left', 'improvement')"
              [disabled]="improvementDivIsAtStart()"
            ></p-button>
            <p-button
              icon="pi pi-chevron-right"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              styleClass="h-2rem w-2rem"
              (onClick)="scroll('right', 'improvement')"
              [disabled]="improvementDivIsAtEnd()"
            ></p-button>
          </div>
        </div>

        <div
          #improvementScroll
          class="custom-scrollbar grid w-full snap-x snap-mandatory grid-cols-1 gap-4 scroll-smooth lg:flex lg:overflow-x-auto lg:pb-4"
        >
          @for (area of improvementAreas(); track $index) {
            <div
              class="flex flex-none snap-start flex-col justify-between rounded-xl border-l-4 border-red-500 bg-slate-50 p-4 shadow-sm lg:w-[250px]"
            >
              <div class="flex flex-col">
                <div class="flex items-center justify-between">
                  <span class="text-sm font-bold uppercase text-red-600">{{ area.title }}</span>
                </div>
                <div class="mb-2 text-xs font-bold uppercase text-red-600">
                  Criticità {{ $index + 1 }}
                </div>
                <p class="m-0 text-base font-semibold leading-snug text-slate-800">
                  {{ area.details }}
                </p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </ng-container>
</lib-card>
